const React = require('react');
const SharedConstants = require('../../../../shared/sharedConstants');
import { IncubatorCard } from './incubatorCard.jsx.js';
import { Grid } from '@material-ui/core';


export class IncubatorList extends React.Component {
   constructor(props) {
      super(props);
   }

   render() {
      if (this.props.hideWhenEmpty && this.props.portfolioList.length === 0) return <div />;
      let {type,portfolioList} = this.props;
      let portfolios = portfolioList.map((portfolio) => {
         let linkTo = '/portfolio?idPortfolio=' + portfolio.id;
         if (portfolio.privacyType === SharedConstants.PortfolioType.Sponsored
            || portfolio.privacyType === SharedConstants.PortfolioType.SponsoredPrivate) {

            linkTo = '/incubator?idIncubator=' + portfolio.id;
         }

         return (
            <Grid item md={6} key={portfolio.id}>
               <IncubatorCard type={type} linkTo={linkTo} portfolio={portfolio}/>
            </Grid>
         )
      });

      return (portfolios);
   }
}; 